<header id="page-topbar" class="container" *ngIf="!loginOrLandingOnly">
  <div class="navbar-header" *transloco="let t; read: 'common.topBar'">
    <div class="d-flex">
      <div class="header-item">
        <a *ngIf="brandLogo$ | async as brandLogo" class="logo">
          <span class="logo-lg">
            <img [src]="brandLogo" class="image-logo" alt="" />
          </span>
          <span class="logo-sm">
            <img [src]="brandLogo" class="sm-image-logo" alt="" />
          </span>
        </a>
      </div>

      <div *ngIf="windowWidth > mobileScreenWidth" class="d-flex">
        <app-header-content *ngIf="user"></app-header-content>
      </div>
    </div>

    <div class="d-flex">
      <div *ngIf="user" class="d-inline-block dropdown" ngbDropdown #dropdownRef>
        <button
          ngbDropdownToggle
          type="button"
          class="dropdown-toggle btn header-item waves-effect"
          id="page-header-user-dropdown"
          (click)="toggleDropdown()"
        >
          <span class="d-xl-inline-block font-bold" key="t-henry">{{ user?.name }} {{ user?.family_name }} </span>
          <i class="mdi mdi-chevron-down d-xl-inline-block"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <a class="dropdown-item" (click)="goToProfile()"
            ><i class="bx bx-user font-size-16 align-middle me-1"></i> <span key="t-logout">{{ t("userProfile") }}</span></a
          >

          <ng-container *ngIf="subscription$ | async as subscription">
            <ng-container *ngIf="subscription.periodLimit">
              <div class="dropdown-divider"></div>

              <div class="text-item">
                <b>{{ t("creditBalance") }}</b>
              </div>

              <div class="text-item" *ngIf="!subscription.isTrial">
                {{ t("p&bDate") }} <i>{{ periodEndDate }}</i>
              </div>

              <div class="text-item" *ngIf="subscription.isTrial && periodEndDays > 0" style="color: red">
                {{ periodEndDays }} {{ t("trialDaysLeft") }}
              </div>

              <div class="text-item" *ngIf="subscription.isTrial && periodEndDays <= 0" style="color: red">
                {{ t("trialPeriodEnded") }}
              </div>

              <div class="text-item">
                {{ subscription.isTrial ? t("trialLimit") : t("monthlyLimit") }}
                <i *ngIf="subscription.periodLimit < 30000"
                  >{{ t("used") }} <b>{{ subscription.count }}</b> {{ t("of") }} <b>{{ subscription.periodLimit }}</b>
                  {{ t("messages") }}</i
                >
                <i *ngIf="subscription.periodLimit >= 30000">No Limit*</i>
              </div>

              <div *ngIf="isMinLocationManager && !isMobileApp">
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="{{ adminPortalUrl }}" target="blank">
                  <i class="bx bx-dollar-circle font-size-16 align-middle me-1"></i>
                  <span>{{ t("adminPanel") }}</span>
                </a>
              </div>
            </ng-container>
          </ng-container>

          @if(hasCfsTerminals) {
            <div class="dropdown-divider"></div>

            <a class="dropdown-item" (click)="customerScreen()">
              <img class="dropdown-item__icon me-1" src="assets/images/link.svg" alt="" />
              <span key="t-logout">{{ t("connectToCFS") }}</span></a
            >

            <div class="dropdown-divider"></div>

            <a class="dropdown-item" (click)="updateCFSCarousel()">
              <img class="dropdown-item__icon me-1" src="assets/images/link.svg" alt="" />
              <span key="t-logout">{{ t("updateCFSCarousel") }}</span></a
            >
          }

          @if (hasLogoutButton) {
          <div class="dropdown-divider"></div>

          <a class="dropdown-item text-danger" (click)="logout()"
            ><i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span key="t-logout">{{ t("logout") }}</span></a
          >
          }

          <div class="dropdown-divider"></div>

          <a class="dropdown-item" href="https://clearline.crunch.help" target="_blank">
            <i class="bx bx-help-circle font-size-16 align-middle me-1"></i>
            <span>{{ t("help&FAQ") }}</span>
          </a>


          @let navigateHome = navigateHomeFeature$ | async;
          @if (navigateHome) {
            <div class="dropdown-divider"></div>

            <a (click)="navigateToHome()" class="dropdown-item">
              <span key="t-logout"> {{ navigateHome.label }} </span>
            </a>
          }
        </div>
      </div>

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle waves-effect"></button>
      </div>
    </div>
  </div>

  <div *ngIf="windowWidth <= mobileScreenWidth" class="navbar-header d-block header-item-xs">
    <app-header-content *ngIf="user"></app-header-content>
  </div>
</header>
